module.exports = __webpack_public_path__ + "static/media/noon_en.9bc2d748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/noon_en.svg
// module id = 190
// module chunks = 2